import React, { memo } from 'react';
import ImmoAssistantModal from './ImmoAssistantModal';
import ChatButton from './ImmoAssistantButton';
import { useIntl } from '@/i18n';
import useNavigationPaths from '@/customHooks/useNavigationPaths.hook';
import { IMMO_ASSISTANT } from '@/domain/routes';
import { useGetAinavioAssistantIframe } from '@/apiHooks/immoAssistant.hook';
import { useFeature } from '@/apiHooks/featureSwitches.hook';
import { Feature } from '@/@types/featureSwitch';

export const ImmoAssistant = () => {
  const { t } = useIntl();
  const isImmoAssistantEnabled = useFeature(Feature.AINAVIO_CHAT_BOT);
  const { nestedPath, navigateToNestedPath, clearNestedPath } = useNavigationPaths();
  const isModalOpen = nestedPath === IMMO_ASSISTANT;
  const { initializing, iframeUrl } = useGetAinavioAssistantIframe(isImmoAssistantEnabled && isModalOpen);
  const handleOpenModal = () => {
    navigateToNestedPath(IMMO_ASSISTANT);
  };

  const handleCloseModal = () => {
    clearNestedPath();
  };

  if (!isImmoAssistantEnabled) {
    return null;
  }

  return (
    <>
      <ChatButton onClick={handleOpenModal} />
      <ImmoAssistantModal
        isVisible={isModalOpen}
        onClose={handleCloseModal}
        isIframeUrlPending={initializing}
        url={iframeUrl}
        title={t({ id: 'immoAssistant.header' })}
        pageContext='meinplus'
      />
    </>
  );
};

export default memo(ImmoAssistant);
